export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS'
export const CUSTOMER_FAILURE = 'CUSTOMER_FAILURE'

export const customerData = (customer) =>{
    return (dispatch, getState) => {
        dispatch({ type: CUSTOMER_SUCCESS, customer });
    }
}